import axios from 'axios';

export const GET_NOTICE_BOARD = '[NOTICE APP] GET NOTICE BOARD';
export const POST_NOTICE_BOARD = '[NOTICE APP] POST NOTICE BOARD';
export const PUT_NOTICE_BOARD = '[NOTICE APP] PUT NOTICE BOARD';
export const PATCH_DELETE_NOTICE_BOARD = '[NOTICE APP] PATCH DELETE NOTICE BOARD';
export const POST_SET_VIEWED = '[NOTICE APP] POST SET IS VIEWED';
export const PATCH_STARRED = '[NOTICE APP] PATCH SET STARRED';
export const PATCH_FILE = '[NOTICE APP] PATCH FILE';
export const SET_TABLE = '[NOTICE APP] SET_TABLE';
export const OPEN_NEW_MODAL = '[NOTICE APP] CREATE NOTICE';
export const CLOSE_NEW_MODAL = '[NOTICE APP] CLOSE NEW CONTACT DIALOG';
export const OPEN_EDIT_MODAL = '[NOTICE APP] OPEN EDIT CONTACT DIALOG';
export const CLOSE_EDIT_MODAL = '[NOTICE APP] CLOSE EDIT CONTACT DIALOG';
export const SET_CHECKED = '[NOTICE APP] SET CHECKED';
export const SET_FAVORITE = '[NOTICE APP] SET FAVORITE';
export const OPEN_EDIT_TOOLTIP = '[NOTICE APP] OPEN EDIT TOOLTIP';
export const CLOSE_EDIT_TOOLTIP = '[NOTICE APP] CLOSE EDIT TOOLTIP';
export const OPEN_LINK = '[NOTICE APP] OPEN LINK';
export const SEARCH_NOTICE = '[NOTICE APP] SEARCH NOTICE';
//export const GET_NOTICES = '[NOTICE APP] GET NOTICES';
export const SET_NOTICE_TAB_NUM  = '[NOTICE APP] SET NOTICE TAB NUM';
export const OPEN_VIEW_FULLPAGE = '[NOTICE APP] OPEN VIEW FULL PAGE';
export const FILTER_CHECKBOX = '[NOTICE APP] FILTER ON FULL NOTICE BOARD';
export const IS_VIEWED = '[NOTICE APP] IF NOTICE IS VIEWED';
export const SET_SEEN_BY = '[NOTICE APP] WHO HAVE SEEN THE NOTICE';
export const NOTICE_BOARD_DATA_LIST = '[NOTICE APP] DATA FROM NOTICE TABLE';
export const UPDATE_NOTICE = '[NOTICE APP] UPDATE NOTICE';
export const CREATE_NOTICE_BOARD = '[NOTICE APP] CREATE NOTICE BOARD LIST';
export const NOTICE_BOARD_ATTACHMENT = '[NOTICE APP] NEW ATTACHMENT NOTICE BOARD';
export const NOTICE_BOARD_UPDATE_ATTACHMENT = '[NOTICE APP] UPDATED ATTACHMENT NOTICE BOARD';
export const MODAL_DELETE_NOTICE_ACTION = '[NOTICE APP] HANDLING DELETE NOTICE';
export const HANDLE_MODAL_HOOK = '[NOTICE APP] HANDLE MODAL HOOK';
export const DELETE_NOTICE_ACTION = '[NOTICE APP] DELETE NOTICE FROM NOTICE BOARD';
export const NOTICES_GET_PROJECTS = '[NOTICE APP] GET USER PROJECTS';
export const NOTICES_GET_PRIVATE_GROUP_TYPE = '[NOTICE APP] GET USER GROUP TYPE';



const tableData = [
    {index: 0, posted: 'Feb 27, 2021 08:34', exp: 'Dec 27, 2021', shareWith: [{ title: 'other',},{ title: 'Mo stuff', }], projectBranch:[{title: 'Head Office Tokyo(Architecture 3)'},{ title: 'Tokyo(Architecture 1)'},{ title: 'Head Office Tokyo(Civil 1)'},], user: 'Uttam Dwivedi', email: 'uttam@ad-hzm.co.jp', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', attachment: ['fake-attachment.jpg'], readBy: '5/8', isImportant: true, isFavorite: false, isUser: false, url: 'https://custom-url-uttam.com', isViewed: false,},
    {index: 1, posted: 'Jun 28, 2021 08:34', exp: 'Dec 28, 2021', shareWith: [{ title: 'other',},{ title: 'Mo stuff', }], projectBranch:[{ title: 'Tokyo(Architecture 1)'},{ title: 'Head Office Tokyo(Civil 1)'},], user: 'Arthur Morgan', email: 'arthur.morgan@ad-hzm.co.jp', content: 'okay let\'s test the notice', attachment: ['fake-attachment_2.jpg'], readBy: '2/8', isImportant: true, isFavorite: false, isUser: true, url: 'https://google.com', isViewed: false,},
    {index: 2, posted: 'Jul 29, 2021 08:34', exp: 'Dec 29, 2021', shareWith: [{ title: 'Mo stuff', }], projectBranch:[{title: 'Head Office Tokyo(Architecture 3)'},],  user: 'Julien', email: 'julien@ad-hzm.co.jp', content: 'Testing notice board, including Redux and stuff', attachment: [], readBy: '2/8', isImportant: false, isFavorite: true, isUser: false, url: false, isViewed: false,},
    {index: 3, posted: 'Aug 30, 2021 08:34', exp: 'Dec 30, 2021', shareWith: [{ title: 'Mo stuff', }], projectBranch:[{title: 'Head Office Tokyo(Architecture 3)'},{ title: 'Head Office Tokyo(Civil 1)'},],  user: 'Dutch Van Der Linde', email: 'dutch@ad-hzm.co.jp', content: 'Not visible while you dont scroll', attachment: [], readBy: '6/8', isImportant: false, isFavorite: false, isUser: false, url: 'https://custom-url-julien2.com', isViewed: false,},
    {index: 4, posted: 'Nov 02, 2021 08:34', exp: 'Dec 30, 2021', shareWith: [{ title: 'other',},{ title: 'Mo stuff', }], projectBranch:[{title: 'Head Office Tokyo(Architecture 3)'},{ title: 'Tokyo(Architecture 1)'},{ title: 'Head Office Tokyo(Civil 1)'},],  user: 'Andrew Milton', email: 'andrew@ad-hzm.co.jp', content: 'Testing notice board, including Redux and stuff', attachment: [], readBy: '2/8', isImportant: false, isFavorite: true, isUser: false, url: false, isViewed: false,},
    {index: 5, posted: 'Nov 12, 2021 08:34', exp: 'Jan 02, 2022', shareWith: [{ title: 'Mo stuff', }], projectBranch:[{title: 'Head Office Tokyo(Architecture 3)'},{ title: 'Tokyo(Architecture 1)'},{ title: 'Head Office Tokyo(Civil 1)'},],  user: 'Nick', email: 'nick@ad-hzm.co.jp', content: 'Testing noiewf iowejbf wncluding Redux and stuff', attachment: [], readBy: '2/8', isImportant: false, isFavorite: true, isUser: false, url: false, isViewed: false,},
    {index: 6, posted: 'Nov 29, 2021 08:34', exp: 'Jan 03, 2022', shareWith: [{ title: 'Mo stuff', }], projectBranch:[{ title: 'Head Office Tokyo(Civil 1)'},],  user: 'John Marston', email: 'john@ad-hzm.co.jp', content: 'You can just use default function parameters to define the initial state in the reducer itself like this with simply an or operator. The initial state for user will be first checked in the local storage and if it s null then it ll be an empty string.', attachment: ['fake-attachment_3.jpg'], readBy: '2/8', isImportant: false, isFavorite: true, isUser: true, url: 'https://v4.mui.com/', isViewed: false,},
]


const usersListSeenBy = [
    {index: 0, user: 'Uttam Dwivedi', initial:'UD', bg_color:'#5BB2B8', email: 'uttam@ad-hzm.co.jp', isViewed: false, isCreator: true,},
    {index: 1, user: 'Arthur Morgan', initial:'AM', bg_color:'#C9BC78', email: 'arthur.morgan@ad-hzm.co.jp', isViewed: true, isCreator: false,},
    {index: 2, user: 'Julien', initial:'J', bg_color:'#B85B5B', email: 'julien@ad-hzm.co.jp', isViewed: false, isCreator: false,},
    {index: 3, user: 'Tron', initial:'T', bg_color:'#C9BC78', email: 'tron@ad-hzm.co.jp', isViewed: true, isCreator: false,},
    {index: 4, user: 'Clue', initial:'C', bg_color:'#7191C1', email: 'clue@ad-hzm.co.jp', isViewed: false, isCreator: false,},
    {index: 5, user: 'Nick Kamimura', bg_color:'#7191C1', initial:'NK', email: 'nick@ad-hzm.co.jp', isViewed: true, isCreator: false,},
    {index: 6, user: 'Koderboxx', bg_color:'#B85B5B', initial:'K', email: 'koderboxx@ad-hzm.co.jp', isViewed: true, isCreator: false,},
    {index: 3, user: 'Dutch Van Der Linde', initial:'DV', bg_color:'#5BB2B8', email: 'dutch@ad-hzm.co.jp', isViewed: true, isCreator: false,},
    {index: 4, user: 'Andrew Milton', initial:'AM', bg_color:'#7191C1', email: 'andrew@ad-hzm.co.jp', isViewed: false, isCreator: false,},
    {index: 5, user: 'John Marston', bg_color:'#5BB2B8', initial:'JM', email: 'john@ad-hzm.co.jp', isViewed: false, isCreator: false,},
]

//::GET - FILL NOTICE TABLE
export function getNoticeBoard(){
    return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
        let companyID = localStorage.getItem('persistCompanyID');
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {
                "Authorization": `Token ${token}`,
            }
		};

		const request = axios.get(process.env.REACT_APP_SERVER + '/api/notice/notice-events?companyID=' + companyID + '&project_uuid=' + localStorage.getItem('persistProjectUUID'), headersToken);
		
		return request.then(response => {
            console.log('Successfully GET Notice Board', response.data);
			return dispatch({
				type: GET_NOTICE_BOARD,
				payload: response.data,
			});
		}).catch( error =>{
            console.log('ERROR in GET Notice Board', error);
		})
	};
}


//::POST - CREATE NOTICE
export function postNoticeBoard(noticeData){
    return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
        let companyID = localStorage.getItem('persistCompanyID');
		const headersToken = {
			'Content-Type': 'multipart/form-data',
			headers: {
                "Authorization": `Token ${token}`,
            }
		};
        console.log('NOTICE BORD DATA ==> ', noticeData)
		const request = axios.post(process.env.REACT_APP_SERVER + '/api/notice/notice-events', 
        {
            "content" : noticeData.content,
            "companyID": companyID,
            "projects" : noticeData.projects,
            "groupType" : noticeData.groupType,
            "startdate": noticeData.posted,
            "enddate": noticeData.exp,
            "attachment": noticeData.attachment,
            "notice_url": noticeData.url,
            "important": noticeData.isImportant,
            "starred": false,
        
        }, headersToken);
		
		return request.then(response => {
            console.log('Successfully Posted Notice Board', response.data);
            dispatch(getNoticeBoard());
			return dispatch({
				type: POST_NOTICE_BOARD,
				payload: response.data,
			});
		}).catch( error =>{
            console.log('ERROR in Notice Board', error);
		})
	};
}

//::PUT - UPDATE NOTICE
export function putNoticeBoard(noticeData){
    return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
        let companyID = localStorage.getItem('persistCompanyID');
		const headersToken = {
			'Content-Type': 'multipart/form-data',
			headers: {
                "Authorization": `Token ${token}`,
            }
		};
        console.log('NOTICE BORD DATA ==> ', noticeData)
		const request = axios.put(process.env.REACT_APP_SERVER + '/api/notice/notice-events', 
        {
            "content" : noticeData.content,
            "companyID": companyID,
            "projects" : noticeData.projects,
            "groupType" : noticeData.groupType,
            "startdate": noticeData.posted,
            "enddate": noticeData.exp,
            "attachment": noticeData.attachment,
            "notice_url": noticeData.url,
            "important": noticeData.isImportant,
            "starred": false,
            "notice_uuid" : noticeData.uuid,
        
        }, headersToken);
		
		return request.then(response => {
            console.log('Successfully UPDATE Notice Board', response.data);
            dispatch(getNoticeBoard());
			return dispatch({
				type: PUT_NOTICE_BOARD,
				payload: response.data,
			});
		}).catch( error =>{
            console.log('ERROR in UPDATE Notice Board', error);
		})
	};
}


//::PATCH - DELETE NOTICE
export function patchDeleteNoticeBoard(noticeData){
    return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'multipart/form-data',
			headers: {
                "Authorization": `Token ${token}`,
            }
		};
        console.log('NOTICE BORD DATA ==> ', noticeData)
		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/notice/notice-events', 
        {
            "projects" : noticeData.projects,
            "notice_uuid" : noticeData.uuid,
        
        }, headersToken);
		
		return request.then(response => {
            console.log('Successfully DELETE Notice Board', response.data);
            dispatch(getNoticeBoard());
			return dispatch({
				type: PATCH_DELETE_NOTICE_BOARD,
				payload: response.data,
			});
		}).catch( error =>{
            console.log('ERROR in DELETE Notice Board', error);
		})
	};
}

//::POST - SET AS VIEWED
export function postSetViewed(_notice_uuid){
    return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {
                "Authorization": `Token ${token}`,
            }
		};

        const data = {
            companyID : localStorage.getItem('persistCompanyID'),
            notice_uuid : _notice_uuid
        };

		const request = axios.post(process.env.REACT_APP_SERVER + '/api/notice/notice-view-action',data, headersToken);
		return request.then(response => {
            console.log('Successfully Posted Set as Viewed', response.data);
            //dispatch(getNoticeBoard());
			return dispatch({
				type: POST_SET_VIEWED,
				payload: response.data,
			});
		}).catch( error =>{
            console.log('ERROR in Notice Posted Set as Viewed', error);
		})
	};
}

//::POST - SET AS STARRED
export function patchStared(_notice_uuid, _isStarred){
    return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {
                "Authorization": `Token ${token}`,
            }
		};

        console.log("STARRED +++> ", _notice_uuid, _isStarred)
        const data = {
            is_starred : _isStarred,
            notice_uuid : _notice_uuid
        };

		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/notice/notice-view-action',data, headersToken);
		return request.then(response => {
            console.log('Successfully Posted Set Starred', response.data);
            dispatch(getNoticeBoard());
			return dispatch({
				type: PATCH_STARRED,
				payload: response.data,
			});
		}).catch( error =>{
            console.log('ERROR in Notice Posted Set Starred', error);
		})
	};
}

//::DELETE ATTACHMENT
export function patchFile(_file_uuid){
    return async (dispatch) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {
                "Authorization": `Token ${token}`,
            }
		};

        console.log("FILE +++> ", _file_uuid)
        const data = {
            file_uuid: _file_uuid,
        };

		const request = axios.patch(process.env.REACT_APP_SERVER + '/api/notice/notice-file-action',data, headersToken);
		return request.then(response => {
            console.log('Successfully Remove File', response.data);
            dispatch(getNoticeBoard());
			return dispatch({
				type: PATCH_FILE,
				payload: response.data,
			});
		}).catch( error =>{
            console.log('ERROR in Remove File', error);
		})
	};
}



export const deleteNoticeAction = (data) =>{
    return {
        type: DELETE_NOTICE_ACTION,
        payload: data,
    }
}

export const handleModalHook = () =>{
    return {
        type: HANDLE_MODAL_HOOK,
    }
}

export const handleDeleteNoticeAction = (data) =>{
    return {
        type: MODAL_DELETE_NOTICE_ACTION,
        payload : data,
    }
}
export const upDateAttachment = (data) =>{
    return {
        type: NOTICE_BOARD_UPDATE_ATTACHMENT,
        payload : data,
    }
}

export const newAttachment = (data) =>{
    return {
        type: NOTICE_BOARD_ATTACHMENT,
        payload : data,
    }
}

//::GET DATA FROM CLICK TABLE
export const noticeBoardDataList = (data) =>{
    return {
        type: NOTICE_BOARD_DATA_LIST,
        payload: data,
    }
}
export const updateNotice = (data) =>{
    return {
        type: UPDATE_NOTICE,
        payload: data,
    }
}
export const setSeenBy = () =>{
    return {
        type: SET_SEEN_BY,
        payload:usersListSeenBy,
    }
}

export const isViewed = (rowNum) =>{
    return {
        type: IS_VIEWED,
        payload: rowNum,
    }
} 
export function searchNotice(event) {
	return {
		type: SEARCH_NOTICE,
		searchNotice: event.target.value
	};
}
export function searchFilterCheckbox(data) {
	return {
		type: FILTER_CHECKBOX,
		payload: data
	};
}
export const setTable = () =>{
    return {
        type: SET_TABLE,
        payload: tableData,
    }
}
export const openNewModal = () =>{
    return {
        type: OPEN_NEW_MODAL
    };
}
export const closeNewModal = () =>{
    return {
        type: CLOSE_NEW_MODAL
    }
}
export const closeEditTooltip = () =>{
    return {
        type: CLOSE_EDIT_TOOLTIP
    }
}
export const openViewFullPage = (rowNum) =>{
    return {
        type: OPEN_VIEW_FULLPAGE,
        payload: rowNum,
    }
} 
export const openEditModal = (rowNum) =>{
    return {
        type: OPEN_EDIT_MODAL,
        payload: rowNum,
    }
}
export const openEditTooltip = (rowNum) =>{
    return {
        type: OPEN_EDIT_TOOLTIP,
        payload: rowNum,
    }
}
export const makeFavorite = (rowNum) =>{
    return {
        type: SET_FAVORITE,
        payload: rowNum,
    }
}
export const closeEditModal = () =>{
    return{
        type: CLOSE_EDIT_MODAL
    }
}

export const setChecked = (data) =>{
    return{
        type: SET_CHECKED,
        payload: data,
    }
}

export const openLink = () =>{
    return{
        type: OPEN_LINK
    }
}

export const setNoticeTabNm = (num) => {
    return {
        type: SET_NOTICE_TAB_NUM,
        payload: num,
    }
}
export const createNoticeBoard = (data) =>{
    return {
        type: CREATE_NOTICE_BOARD,
        payload: data,
    }
}


//::GET Projects
export function notices_getProjects() {
	return async(dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const companyID = localStorage.getItem('persistCompanyID');
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/project/create-update-project?companyID=' + companyID, headersToken);
		
		return request.then(response => {
			console.log('GET PROJECTS Succesfully', response.data.data);
			return dispatch({
				type: NOTICES_GET_PROJECTS,
				payload: response.data.data,
			});
		}).catch( error =>{
			console.log('Could not load data from PROJECTS', error.response)
		})
	}
}   

//::Get Group Type Private
export function notices_getGroupTypePrivate(){
	return async (dispatch)=>{
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		const companyID = localStorage.getItem('persistCompanyID');
		const request = axios.get(process.env.REACT_APP_SERVER + '/api/common/group-type-private?companyID=' + companyID, headersToken);
		return request.then( response =>{
			console.log('Get Private Group Type succesfully', response.data);
			return dispatch({
				type: NOTICES_GET_PRIVATE_GROUP_TYPE,
				payload: response.data,
			});

		}).catch(error =>{
			console.log('Error, Cold not get Private Group Type', error.response)
		})
	}
}